import { type ReactNode } from "react";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Box } from "ui/box";
import { mergeSx } from "ui/merge-sx";
import {
  EmailHeaderPreview,
  EmailHeaders,
} from "containers/admin/clients/touchpoint/components/email-builder/email-header-preview/email-header-preview";
import { BEE_EMAIL_SELECTOR, BEE_LP_SELECTOR } from "utilities/constants";

interface BuilderPreviewSandboxProps {
  isCommentMode: boolean;
  isMobileView: boolean;
  emailHeaders?: EmailHeaders;
  hideSubjectAndPreheader?: boolean;
  children?: ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
}
export const DesignPreviewSandbox = ({
  isCommentMode,
  isMobileView,
  emailHeaders,
  hideSubjectAndPreheader,
  children,
  className,
  sx,
}: BuilderPreviewSandboxProps) => {
  // Preview HTML and CSS will be namedspaced to avoid conflicts with the app.
  const designPreviewStyles = {
    [`& ${BEE_LP_SELECTOR} .bee-image, 
    & ${BEE_LP_SELECTOR} .bee-divider`]: {
      // Prevent the default overflow: auto from cropping comment trigger
      overflow: "inherit",
    },
    [`& ${BEE_LP_SELECTOR}, & ${BEE_EMAIL_SELECTOR}`]: {
      width: "100%",
      "ul, ol": { margin: "revert", padding: "revert", listStyle: "initial" },
      table: { borderCollapse: "separate" },
    },
    ...(isMobileView && {
      [`& ${BEE_EMAIL_SELECTOR} table`]: {
        minWidth: "100%",
        width: "auto !important",
      },
      [`& ${BEE_EMAIL_SELECTOR} .alignment table`]: {
        minWidth: "unset",
      },
    }),
  };

  const borderColorClass = isCommentMode ? "border-blue-500" : "border-neutrals-200";

  return (
    <Box
      className={`border ${borderColorClass} flex flex-1 flex-col ${className ?? ""}`}
      sx={mergeSx(designPreviewStyles, sx)}
    >
      {emailHeaders && (
        <EmailHeaderPreview
          emailHeaders={emailHeaders}
          isCommentMode={isCommentMode}
          isMobileView={isMobileView}
          hideSubjectAndPreheader={hideSubjectAndPreheader}
          className={`border-b ${borderColorClass}`}
        />
      )}
      <Box data-testid="builder__device-window">{children}</Box>
    </Box>
  );
};
